import { RunMe } from "lib/@components/slot"

const AUTHORING_RIGHTBAR_TAB_IDS = new Set([
    "AuthoringRecommendations",
    "AuthoringDraftHistory",
    "AuthoringGuidance",
    "AuthoringAuthorNotes",
    "AuthoringMacroGuidance",
])

export const filterRightBarToAuthoringTabs = {
    [RunMe]: true,
    priority: 10000,
    fn({ items }) {
        const filtered = items.filter((item) => AUTHORING_RIGHTBAR_TAB_IDS.has(item?.props?.value))
        items.length = 0
        items.push(...filtered)
    },
}

export const clearRightBarRefreshers = {
    [RunMe]: true,
    priority: 10000,
    fn({ items }) {
        items.length = 0
    },
}
